<template>
	<div class="footer">
		<div class="footer_top_box">
			<div
				v-for="(items, indexs) in linksUrl"
				class="footer_title_box"
				:key="indexs"
			>
				<a
					v-for="(item, index) in items"
					:key="index"
					:class="
						index == 0 ? 'footer_title_one' : 'footer_title_two'
					"
					:href="item.link"
					:target="item.terget"
					>{{ item.name }}</a
				>
			</div>
			<div class="footer_wechat_box">
				<img
					style="width:100%;"
					src="../assets/footer/wechat.jpg"
					alt=""
				/>
				<span>热线电话：</span>
				<h5>400-7070-678</h5>
			</div>
		</div>

		<div class="footer_under_box">
			Copyright©1998-{{ new Date().getFullYear() }} DRCNet. All Rights
			Reserved 版权所有 国研网 京ICP证030059号 中关村信用促进会会员证书
			<img style="width:18px;" src="../assets/footer/beian.png" alt="" />
			京公网安备 11010102002958号
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';

export default {
	props: {},
	components: {},
	data() {
		return {
			guid: '',
			linksUrl: [
				[
					{ name: '首页', link: '#/', terget: '' },
					{
						name: '关于我们',
						link: 'http://company.drcnet.com.cn/about.html',
						terget: '_blank',
					},
					{ name: '产品介绍', link: '#/introduce', terget: '' },
					{
						name: '使用帮助',
						link: 'https://www.drcnet.com.cn/help',
						terget: '_blank',
					},
					{
						name: '会员专区',
						link:
							'http://www.drcnet.com.cn/eDRCNet.Order.Web/Order/User/UserMain.aspx',
						terget: '_blank',
					},
				],
				[
					{
						name: '权威声音',
						link:
							'#/column?id=125&name=权威声音&uid=A601&showType=2',
						terget: '',
					},
					{
						name: '中央领导',
						link:
							'#/column?id=125&name=权威声音&uid=A60101&showType=2',
						terget: '',
					},
					{
						name: '地方领导',
						link:
							'#/column?id=125&name=权威声音&uid=A60102&showType=2',
						terget: '',
					},
				],
				[
					{
						name: '政策规划',
						link:
							'#/column?id=13&name=政策规划&uid=A602&showType=2',
						terget: '',
					},
					{
						name: '中央政策',
						link:
							'#/column?id=13&name=政策规划&uid=A6020101&showType=2',
						terget: '',
					},
					{
						name: '地方政策',
						link:
							'#/column?id=13&name=政策规划&uid=A6020102&showType=1-1',
						terget: '',
					},
					{
						name: '政策解读',
						link:
							'#/column?id=13&name=政策规划&uid=A6020103&showType=2',
					},
					{
						name: '国际政策',
						link:
							'#/column?id=13&name=政策规划&uid=A60202&showType=2',
						terget: '',
					},
				],
				[
					{
						name: '动态资讯',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A606',
						terget: '',
					},
					{
						name: '每日推荐',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A60602',
						terget: '',
					},
					{
						name: '气候生态',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A60628',
						terget: '',
					},
					{
						name: '碳排放',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A60632',
					},
					{
						name: '碳市场',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A60633',
					},
					{
						name: '碳金融',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A60634',
						terget: '',
					},
					{
						name: '碳税',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A60635',
					},
					{
						name: '碳汇',
						link: '#/dynamicInfo?id=19&name=动态资讯&uid=A60636',
						terget: '',
					},
				],
				[
					{
						name: '学术论文',
						link: '#/paper?id=6&name=学术论文&uid=A617',
						terget: '',
					},
					{
						name: '宏观经济与可持续发展',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=宏观经济与可持续发展',
						terget: '',
					},
					{
						name: '环境科学与资源利用',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=环境科学与资源利用',
						terget: '',
					},
					{
						name: '工业经济',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=工业经济',
					},
					{
						name: '农业经济',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=农业经济',
						terget: '',
					},

					{
						name: '企业经济',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=企业经济',
						terget: '',
					},
					{
						name: '建筑科学与工程',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=建筑科学与工程',
						terget: '',
					},
					{
						name: '矿业工程',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=矿业工程',
					},
					{
						name: '交通运输',
						link:
							'#/paper?id=6&name=学术论文&uid=A617&paperType=交通运输',
						terget: '',
					},
				],
				[
					{
						name: '实践&案例',
						link:
							'#/column?id=43&name=双碳实践&uid=A620&showType=2',
						terget: '',
					},
					{
						name: '实施方案',
						link: '#/actionPlan?id=9&name=实施方案&uid=1',
						terget: '',
					},
					{
						name: '地方举措',
						link:
							'#/column?id=43&name=双碳实践&uid=A62030&showType=2',
						terget: '',
					},
					{
						name: '企业行动',
						link:
							'#/column?id=43&name=双碳实践&uid=A62031&showType=2',
					},
					{
						name: '典型案例',
						link: '#/column?id=8&name=典型案例&uid=A619&showType=2',
						terget: '',
					},
				],
				[
					{
						name: '特色专题',
						link:
							'#/column?id=47&name=特色专题&uid=A621&showType=2',
						terget: '',
					},
					{
						name: '热点专题',
						link: '#/hotColumn?id=231&name=热点专题&uid=7392',
						terget: '',
					},
					{
						name: '绿金专题',
						link:
							'#/column?id=47&name=特色专题&uid=A62101&showType=2',
						terget: '',
					},
					{
						name: 'ESG专题',
						link:
							'#/column?id=47&name=特色专题&uid=A62129&showType=2',
					},
				],
			],
		};
	},
	computed: {},
	methods: {
		//点击链接跳转页面
		pageToUrl(url, num = 0) {
			// //console.log(url.split('?')[1].split('&')[1].split('=')[1],num,'num');
			let _name = url
				.split('?')[1]
				.split('&')[1]
				.split('=')[1];
			if (
				_name == '能源数据' ||
				_name == '交易数据' ||
				_name == '排放数据' ||
				_name == '产品数据'
			) {
				let _this = this;
				let tmpGuid = this.guid;
				api.iflogin(tmpGuid).then((res2) => {
					function showData(val) {
						return val;
					}
					let res = eval(res2);

					if (!res.UserToken) {
						_this.$message.error('请先登录！');
						window.location.href =
							'http://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=http://' +
							window.location.host +
							'/index.html#/Index';
					} else {
						_this.ifRightsFn().then((ress) => {
							if (!ress) {
								this.$message.error('您暂无权限，请先购买！');
								return;
							} else {
								this.$router.push({ path: url });
								window.location.reload();
							}
						});
					}
				});
			} else {
				this.$router.push({ path: url });
				window.location.reload();
			}
		},
		//判断是否有权限
		ifRightsFn() {
			return new Promise(function(resolve, reject) {
				api.weighterRights('2682').then((res) => {
					resolve(res.data);
				});
			});
		},
		figgerPrint() {
			let _this = this;

			// let myOptions = {
			//   excludes: {
			//     language: true,
			//     colorDepth: true,
			//     deviceMemory: true,
			//     pixelRatio: true,
			//     availableScreenResolution: true,
			//     timezoneOffset: true,
			//     timezone: true,
			//     sessionStorage: true,
			//     localStorage: true,
			//     indexedDb: true,
			//     addBehavior: true,
			//     openDatabase: true,
			//     cpuClass: true,
			//     doNotTrack: true,
			//     plugins: true,
			//     canvas: true,
			//     webglVendorAndRenderer: true,
			//     adBlock: true,
			//     hasLiedLanguages: true,
			//     hasLiedResolution: true,
			//     hasLiedOs: true,
			//     hasLiedBrowser: true,
			//     touchSupport: true,
			//     audio: false,
			//     enumerateDevices: true,
			//     hardwareConcurrency: true,
			//   },
			// };
			let myOptions = getDRCNetFingerConfig();
			// //console.log(myOptions,'myOptions')
			if (window.requestIdleCallback) {
				Fingerprint2.get(myOptions, function(components) {
					// //console.log(components,'components');
					var option = components
						.filter(function(pair) {
							if (
								pair.key == 'userAgent' ||
								pair.key == 'availableScreenResolution'
							) {
								return false;
							}
							return true;
						})
						.map(function(pair) {
							return pair.value;
						});
					var murmur = Fingerprint2.x64hash128(option.join(), 31);
					// document.querySelector("#fp").textContent = murmur;
					_this.guid = murmur;
					// //console.log(murmur, "murmur1");
				});
			} else {
				setTimeout(() => {
					Fingerprint2.get(myOptions, function(components) {
						// //console.log(components,'components');
						var option = components
							.filter(function(pair) {
								if (
									pair.key == 'userAgent' ||
									pair.key == 'availableScreenResolution'
								) {
									return false;
								}
								return true;
							})
							.map(function(pair) {
								return pair.value;
							});
						var murmur = Fingerprint2.x64hash128(option.join(), 31);
						// document.querySelector("#fp").textContent = murmur;
						_this.guid = murmur;
						//console.log(murmur, "murmur2");
					});
				}, 500);
			}
		},
	},
	created() {
		window.that = this;
		this.figgerPrint();
	},
	mounted() {},
};
</script>
<style scoped lang="less">
.footer {
	width: 100%;
	height: 368px;
	background: url('../assets/footer/footerbg.png') no-repeat center;
	background-size: cover;
}
.footer_main_box {
	width: 1200px;
	overflow: hidden;
	margin: 0 auto;
}
.footer_top_box {
	width: 1200px;
	height: 345px;
	margin: 0 auto;
	position: relative;
}
.footer_title_box {
	float: left;
	margin-top: 45px;
	margin-right: 50px;
}
.footer_title_one {
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 600;
	color: #ffffff;
	display: block;
	text-align: left;
	margin-bottom: 26px;
	height: 21px;
}
.footer_title_two {
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #ffffff !important;
	display: block;
	text-align: left;
	margin-bottom: 10px;
}
.footer_title_two a {
	color: #ffffff !important;
}
.footer_wechat_box {
	position: absolute;
	top: 45px;
	right: 0;
	width: 118px;
	display: block;
}
.footer_wechat_box span {
	height: 11px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #ffffff;
	margin-top: 20px;
	display: block;
}
.footer_wechat_box h5 {
	height: 14px;
	font-size: 18px;
	font-family: Arial;
	font-weight: 400;
	color: #ffffff;
	margin-top: 9px;
}

.footer_under_box {
	width: 100%;
	height: 58px;
	line-height: 58px;
	background: #292f2b;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #ffffff;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue